import { CategoryGrid } from '@ui/category/category-grid.tsx';
import { useCategories } from '../../entites/categories';

export const AllCategoriesList = () => {
  const { data } = useCategories();
  return <CategoryGrid items={data} />;
};

